import VueI18n from "./vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);
const locale = document.documentElement.lang;
const i18n = new VueI18n({
  locale,
  messages: {
    [locale]: window.$apTranslations ? window.$apTranslations : {},
  },
});

export default i18n;
